import { Colors, Language, Lightning, Router, Log } from '@lightningjs/sdk'
import SettingsButton from '../components/buttons/SettingsButton'
import { appSettings } from '../lib/AppSettings'

export default class Settings extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      PageTitle: {
        x: 260,
        y: 62,
        w: 580,
        h: 75,
        color: Colors('white').get(),
        text: {
          text: Language.translate('SettingsTitle'),
          textAlign: 'left',
          fontSize: 55,
          fontFace: 'OpenSansbold',
          lineHeight: 75,
        },
      },
      MenuName: {
        x: 260,
        y: 300,
        w: 580,
        h: 75,
        color: Colors('white').get(),
        text: {
          text: Language.translate('MenuName'),
          textAlign: 'left',
          fontSize: 35,
          fontFace: 'OpenSansRegular',
          lineHeight: 45,
        },
      },

      MenuWrapper: {
        x: 260,
        y: 380,
        MenuPrivacy: { w: 700, type: SettingsButton },
        MenuTerms: { w: 700, type: SettingsButton },
        MenuLegal: { w: 700, type: SettingsButton },
      },
      VersionLabel: {
        x: 1800,
        y: 980,
        mountX: 1,
        color: Colors('white').get(),
        text: {
          text: '',
          textAlign: 'right',
          fontSize: 30,
          fontFace: 'OpenSansLight',
          lineHeight: 40,
        },
      },
    }
  }

  _init() {
    if (this.widgets && this.widgets['sidemenu']) {
      this.widgets['sidemenu'].activeMenuItem = 4
    }

    this._menuData = [
      {
        title: Language.translate('MenuPrivacy'),
        descr: `${Language.translate('mnuDescr')}:`,
        qrLink: 'images/qr/privacy-policy.png',
        link: 'https://global.com/privacy-policy/',
      },
      {
        title: Language.translate('MenuTerms'),
        descr: `${Language.translate('mnuDescr')}:`,
        qrLink: 'images/qr/terms-of-use.png',
        link: 'https://global.com/termsofuse/',
      },
      {
        title: Language.translate('MenuLegal'),
        descr: `${Language.translate('mnuDescr')}:`,
        qrLink: 'images/qr/legal.png',
        link: 'https://global.com/legal/',
      },
    ]
    this.tag('MenuPrivacy').buttonData = this._menuData[0]
    this.tag('MenuTerms').buttonData = this._menuData[1]
    this.tag('MenuLegal').buttonData = this._menuData[2]

    this._setState('Idle')
  }

  _inactive() {
    this.stage.gc()
  }

  _firstActive() {
    this.tag('VersionLabel').text = 'v' + this.application.config.version
  }

  _focus() {
    this._setState('MenuPrivacy')
  }

  _unfocus() {
    this._setState('Idle')
  }

  _handleBack() {
    Log.info('Settings:HandleBack')
    appSettings.searchState.searchTerm = null
    //Router.focusWidget('SideMenu')
    Router.back()
  }

  _handleLeft() {
    Router.focusWidget('SideMenu')
  }

  static _states() {
    return [
      class Idle extends this {
        _getFocused() {
          return this
        }
      },

      class MenuPrivacy extends this {
        $enter() {
          this.tag('MenuPrivacy').patch({
            smooth: { y: [0, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
          this.tag('MenuTerms').patch({
            smooth: { y: [340, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
          this.tag('MenuLegal').patch({
            smooth: { y: [440, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
        }

        _handleDown() {
          this._setState('MenuTerms')
        }

        _getFocused() {
          return this.tag('MenuPrivacy')
        }
      },

      class MenuTerms extends this {
        $enter() {
          this.tag('MenuPrivacy').patch({
            smooth: { y: [0, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
          this.tag('MenuTerms').patch({
            smooth: { y: [100, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
          this.tag('MenuLegal').patch({
            smooth: { y: [440, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
        }
        _handleDown() {
          this._setState('MenuLegal')
        }

        _handleUp() {
          this._setState('MenuPrivacy')
        }

        _getFocused() {
          return this.tag('MenuTerms')
        }
      },

      class MenuLegal extends this {
        $enter() {
          this.tag('MenuPrivacy').patch({
            smooth: { y: [0, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
          this.tag('MenuTerms').patch({
            smooth: { y: [100, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
          this.tag('MenuLegal').patch({
            smooth: { y: [200, { duration: 0.2, timingFunction: 'ease-in' }] },
          })
        }
        _handleUp() {
          this._setState('MenuTerms')
        }

        _getFocused() {
          return this.tag('MenuLegal')
        }
      },
    ]
  }
}
